import { UserKeys } from '../../../../api/users-api';
import {
  isAbleToSeeUIElement,
  UserRoles,
} from '../../../../utils/roles/client-roles';
import { useQueryClient } from '@tanstack/react-query';
import { Dispatch, SetStateAction } from 'react';
import SharedToolbar from '../../../../shared/shared-toolbar-latest';
import CreateButton from '../../../../shared/buttons/create-button';
import SharedIconButton from '../../../../shared/buttons/shared-icon-button';

interface PersonalContactsGridToolbarProps {
  userEmail: string;
  selectedLabel: string;
  selectedRows: string[];
  userView: boolean;
  userRoles: string[];
  setOpenAddContact: Dispatch<SetStateAction<boolean>>;
  setOpenDeleteContacts: Dispatch<SetStateAction<boolean>>;
  setOpenMoveContacts: Dispatch<SetStateAction<boolean>>;
  isLoading: boolean;
  isExporting: boolean;
  handleMutate: () => void;
}

export default function PersonalContactsGridToolbar({
  userEmail,
  selectedLabel,
  selectedRows,
  userView,
  userRoles,
  setOpenAddContact,
  setOpenDeleteContacts,
  setOpenMoveContacts,
  isLoading,
  isExporting,
  handleMutate,
}: PersonalContactsGridToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      noColumn
      noFilter
      noQuickFilter={selectedLabel !== 'contactGroups/all'}
      primaryButtons={
        <CreateButton
          onClick={() => {
            if (!isLoading) {
              setOpenAddContact(true);
            }
          }}
          disabled={
            (!userView &&
              !isAbleToSeeUIElement(userRoles, UserRoles.AddContacts.value)) ||
            selectedLabel === 'contactGroups/blocked' ||
            selectedLabel === 'contactGroups/chatBuddies'
          }
          label="Add Contact"
          tooltipLabel={
            selectedLabel === 'contactGroups/blocked' ||
            selectedLabel === 'contactGroups/chatBuddies'
              ? 'Cannot add contacts to the blocked or chat label.'
              : ''
          }
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="delete"
            onClick={() => setOpenDeleteContacts(true)}
            disabled={
              selectedRows.length === 0 ||
              (!userView &&
                !isAbleToSeeUIElement(
                  userRoles,
                  UserRoles.RemoveContacts.value
                ))
            }
            tooltipLabel="Delete"
          />
          <SharedIconButton
            variant="transfer"
            onClick={() => setOpenMoveContacts(true)}
            disabled={
              selectedRows.length === 0 ||
              (!userView &&
                !isAbleToSeeUIElement(userRoles, UserRoles.MoveContacts.value))
            }
            tooltipLabel="Move"
          />
          <SharedIconButton
            variant="export"
            onClick={handleMutate}
            disabled={
              (!userView &&
                !isAbleToSeeUIElement(
                  userRoles,
                  UserRoles.ExportContacts.value
                )) ||
              selectedLabel != 'contactGroups/all'
            }
            isLoading={isExporting}
            tooltipLabel="Export"
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: [UserKeys.Labels, userEmail],
              });
              queryClient.invalidateQueries({
                queryKey: [UserKeys.ContactGroup, userEmail, selectedLabel],
              });
              queryClient.invalidateQueries({
                queryKey: [UserKeys.Contacts, userEmail, selectedLabel],
              });

              queryClient.invalidateQueries({
                queryKey: [UserKeys.ContactSearch, userEmail],
              });
            }}
            tooltipLabel="Refresh"
          />
        </>
      }
    />
  );
}
